import React, { createContext, useContext } from 'react';
import NativeCapability from '~/constants/srp/nativeCapability';

type ContextType = {
  capabilities: Record<string, boolean>;
};

const defaultContext: ContextType = {
  capabilities: {}
};

const NativeContext = createContext<ContextType>(defaultContext);

export type OwnProps = ContextType;

export function NativeContextProvider({
  children,
  ...value
}: React.PropsWithChildren<OwnProps>) {
  return (
    <NativeContext.Provider value={value}>{children}</NativeContext.Provider>
  );
}

export function useIsNativeCapabilityActive(feature: NativeCapability) {
  const { capabilities } = useContext(NativeContext);

  return capabilities[feature] ?? false;
}

export function useNativeSupportsDismissBanner() {
  return useIsNativeCapabilityActive(NativeCapability.DismissBanner);
}

export default NativeContext;
